module.exports = __webpack_public_path__ + "static/media/guilherme.d1ad39bd.jfif";